import { post } from '@/utils/request'

/**
 * 管理员查看导购APP清单
 * @param {String}  app_name   app名字
 * @param {String} status 状态
 * @param {String} telephone 淘客手机号码
 * @param {String} id ID
 * @param {String} page 页码
 * @param {String} pagesize 分页大小
 */
export function admin_plugin_app_list(data) {
  return post('admin_plugin_app_list', data)
}

/**
 * 管理员查看导购APP信息
 * @param {String}  id   id
 */
export function admin_plugin_app_info(data) {
  return post('admin_plugin_app_info', data)
}

/**
 * 管理员上传导购APP
 * @param {String}  id   app id
 * @param {String}  market   market
 * @param {String}  appfile  文件
 */
export function admin_plugin_app_upload(data) {
  return post('admin_plugin_app_upload', data, {
    clear: false,
    config: {
      timeout: 100000,
      transformRequest: [(data) => {
        // data => formdata
        let formD = new FormData();
        Object.keys(data).forEach((key) => {
          if (data[key] !== null) {
            formD.append(key, data[key])
          }
        })
        return formD
      }],
      onUploadProgress: (progressEvent) => {
        var complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
        console.log(complete)
      },
    },
  })
}

/**
 * 管理员上传导购APP
 * @param {String}  id   app id
 * @param {String}  status   status 0开发中 1开发完成
 */
export function admin_plugin_app_set(data) {
  return post('admin_plugin_app_set', data)
}








